import { reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { Bus, useTour } from '@orion.ui/orion';

type Props = SetupProps<typeof TourOrderPipelineSetupService.props>

export default class TourOrderPipelineSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	private readonly state = reactive({ warnClient: false });

	readonly _tourOrderPipeline = ref<OrionTour>();

	get warnClient () { return this.state.warnClient;}

	constructor () {
		super();
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourOrderPipeline', this._tourOrderPipeline.value);
		this.registerBusEvent('tour-order-pipeline', (warnClient) => {
			this.state.warnClient = warnClient;
		});
	}

	returnToTourOrderDetails () {
		useTour('tourOrderPipeline').stop();
		useTour('tourOrderDetailsAgency').start();
	}

	scrollToId (id: string) {
		const elem = document.getElementById(id);
		elem?.scrollIntoView();
		return document.getElementById(id);
	}

	updateWarnClient () {
		Bus.emit('OrderDetailsSetupService:order-pipeline-warn-client');
		useTour('tourOrderPipeline').stop();
	}
}
